import styled from 'styled-components';

interface InfoListPageHeaderProps {
  children: JSX.Element;
}

export const InfoListPageHeader = ({ children }: InfoListPageHeaderProps) => {
  return (
    <Container>
      <TextSection>
        <PageTitle>{'지금 인기글 Top 5 🏆'}</PageTitle>
        <PageDescription>{'지금 핫한 정보 한눈에 살펴보세요!'}</PageDescription>
      </TextSection>
      {children}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  padding: 24px var(--radius-large, 16px);

  gap: var(--radius-large, 16px);
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  gap: var(--radius-medium, 8px);
`;

const PageTitle = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;

  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-overflow: ellipsis;

  /* System/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 17px */
`;

const PageDescription = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;

  overflow: hidden;
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-overflow: ellipsis;

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;
